export const getCategoriesTreeForStudio = (studios: any, categories: any, services: any) => {
  return studios.map((studio: any) => {
    const categoriesForStudio = categories.filter((category: any) => {
      return category.studio.id === studio.id
    }).map((category: any) => {
      const childrenWithServices = category.children.map((subCategory: any) => {
        const servicesForSubCategory = studio.services.filter((service: any) => {
          const actualService = services.find((el: any) => service.id === el.id);

          return actualService?.categories?.[0]?.id === subCategory.id;
        });

        return {
          ...subCategory,
          services: servicesForSubCategory,
        };
      });

      const servicesForCategory = studio.services.filter((service: any) => {
        const actualService = services.find((el: any) => service.id === el.id);

        return actualService?.categories?.[0]?.id === category.id;
      });

      return {
        ...category,
        children: childrenWithServices,
        services: servicesForCategory,
      }
    });

    return {
      ...studio,
      categories: categoriesForStudio,
    };
  });
};
